export default __webpack_public_path__ + "static/f9-329d95211e92d76348bee6b6ffd9eda7.svg";